'use strict'

GdtWidget = require './gdt_widget'

$ ->
  $el = $ '.mpp-container .gdt-widget'
  return unless $el.length > 0

  new GdtWidget {
    el: $el
    desktopWrapper: '.mpp-container .gdt-widget-desktop'
    mobileWrapper: '.mpp-container .gdt-widget-mobile'
    place: $('.mpp-container').data()
  }
